import { QueryHookOptions, useQuery } from '@apollo/client'
import gql from 'graphql-tag'
import { useShowErrorsPopup } from '@/hooks'
import { Query, QueryGetDealsArgs } from '@/schemaTypes'

const GET_AUCTION_CLOSE_DEALS = gql`
  query getAuctionCloseDeals($opts: DealOpts) {
    getDeals(opts: $opts) {
      _id
      shop {
        _id
        name
      }
    }
  }
`

type TData = { getDeals: Query['getDeals'] }
type TVariables = QueryGetDealsArgs

export function useGetAuctionCloseDeals(
  opts: QueryHookOptions<TData, TVariables> = {},
) {
  const queryResult = useQuery<TData, TVariables>(GET_AUCTION_CLOSE_DEALS, {
    fetchPolicy: 'network-only',
    ...opts,
  })

  useShowErrorsPopup(queryResult.error)

  return { queryResult, deals: queryResult.data?.getDeals || [] }
}
